import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { Icon } from "@qgiv/core-react";
import {
    CmsConnectedEmailSharingModal,
    ConnectedEmailSharingModal,
} from "../../common/EmailSharingModal";
import "./ReceiptSocialSharing.scss";

const ReceiptSocialSharing = ({
    enableEmailSharing,
    enableFacebookSharing,
    enableTwitterSharing,
    socialShareLabel,
    facebookShareUrl,
    twitterShareUrl,
    setAppEmailModalOpen,
    controlId,
    isCms,
}) => {
    const dispatch = useDispatch();
    const handleFacebookButtonClick = () => {
        window.open(facebookShareUrl, "_blank", "height=475,width=550");
    };

    const handleTwitterButtonClick = () => {
        window.open(twitterShareUrl, "_blank", "height=475,width=550");
    };

    const handleEmailButtonClick = () => {
        dispatch(setAppEmailModalOpen(true));
    };

    return (
        <>
            <div className="social-sharing-grid">
                <div className="social-share-grid-label">
                    <p>{socialShareLabel}</p>
                </div>
                {enableFacebookSharing === 1 && (
                    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
                    <div
                        className="social-sharing-grid__item -cursor--pointer"
                        onClick={handleFacebookButtonClick}
                    >
                        <Icon
                            className="-color--facebook receipt-footer__social-sharing-icon"
                            glyph="facebook-brands"
                            label="Facebook"
                            type="FontAwesome"
                        />
                    </div>
                )}

                {enableTwitterSharing === 1 && (
                    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
                    <div
                        className="social-sharing-grid__item -cursor--pointer"
                        onClick={handleTwitterButtonClick}
                    >
                        <Icon
                            className="-color--twitter receipt-footer__social-sharing-icon"
                            glyph="x-twitter-brands"
                            label="X"
                            type="FontAwesome"
                        />
                    </div>
                )}
                {enableEmailSharing === 1 && (
                    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
                    <div
                        className="social-sharing-grid__item -cursor--pointer"
                        onClick={handleEmailButtonClick}
                    >
                        <Icon
                            className="-color--theme-primary receipt-footer__social-sharing-icon"
                            glyph="envelope-regular"
                            label="Email"
                            type="Icomoon"
                        />
                    </div>
                )}
            </div>
            {isCms ? (
                <CmsConnectedEmailSharingModal controlId={controlId} />
            ) : (
                <ConnectedEmailSharingModal controlId={controlId} />
            )}
        </>
    );
};

ReceiptSocialSharing.propTypes = {
    enableEmailSharing: PropTypes.number.isRequired,
    enableFacebookSharing: PropTypes.number.isRequired,
    enableTwitterSharing: PropTypes.number.isRequired,
    socialShareLabel: PropTypes.string.isRequired,
    facebookShareUrl: PropTypes.string.isRequired,
    twitterShareUrl: PropTypes.string.isRequired,
    setAppEmailModalOpen: PropTypes.func.isRequired,
    controlId: PropTypes.number.isRequired,
    isCms: PropTypes.bool.isRequired,
};

export default ReceiptSocialSharing;
